import Vue from 'vue/dist/vue.esm.js'
const d = document

const is_input = document.querySelector('.mw_wp_form').classList.contains('mw_wp_form_input')
const is_confirm = document.querySelector('.mw_wp_form').classList.contains('mw_wp_form_confirm')

const init = () => {
  // const input_template = d.querySelector('#input')
  // const input_templateDOM = new DOMParser().parseFromString( input_template.innerHTML, 'text/html' )
  // const pref_children = JSON.parse( input_templateDOM.querySelector('[name="__children[都道府県][]"]').value )
  const pref_children = {
    '':'都道府県','北海道':'北海道','青森県':'青森県','岩手県':'岩手県','宮城県':'宮城県','秋田県':'秋田県','山形県':'山形県','福島県':'福島県','茨城県':'茨城県','栃木県':'栃木県','群馬県':'群馬県','埼玉県':'埼玉県','千葉県':'千葉県','東京都':'東京都','神奈川県':'神奈川県','新潟県':'新潟県','富山県':'富山県','石川県':'石川県','福井県':'福井県','山梨県':'山梨県','長野県':'長野県','岐阜県':'岐阜県','静岡県':'静岡県','愛知県':'愛知県','三重県':'三重県','滋賀県':'滋賀県','京都府':'京都府','大阪府':'大阪府','兵庫県':'兵庫県','奈良県':'奈良県','和歌山県':'和歌山県','鳥取県':'鳥取県','島根県':'島根県','岡山県':'岡山県','広島県':'広島県','山口県':'山口県','徳島県':'徳島県','香川県':'香川県','愛媛県':'愛媛県','高知県':'高知県','福岡県':'福岡県','佐賀県':'佐賀県','長崎県':'長崎県','熊本県':'熊本県','大分県':'大分県','宮崎県':'宮崎県','鹿児島県':'鹿児島県','沖縄県':'沖縄県'
  }
  
  const edit_template = d.querySelector('#parentEdit')
  const edit_templateDOM = new DOMParser().parseFromString( edit_template.innerHTML, 'text/html' )

  $('select[name="都道府県"]',edit_templateDOM).each( (i,obj) => {
    $.each(pref_children, (key,val) => $(obj).append( $(`<option value="${key}">${val}</option>`)[0] ))
  })

  edit_template.innerHTML = edit_templateDOM.body.outerHTML
}

if( is_confirm ) init()

export default Vue.component( 'parentEdit', {
  template: '#parentEdit',
  props:{
    is_input: Boolean,
    is_confirm: Boolean,
    formdata: Object
  },
  data () {
    return {
      editdata: {
        p_name_1: this.formdata.p_name_1,
        p_name_2: this.formdata.p_name_2,
        p_furi_1: this.formdata.p_furi_1,
        p_furi_2: this.formdata.p_furi_2,
        zip: this.formdata.zip,
        pref: this.formdata.pref,
        addr: this.formdata.addr,
        bldg: this.formdata.bldg,
        email: this.formdata.email,
        phone: this.formdata.phone,
      }
    }
  },
  mounted () {
    if( is_input ) this.$router.replace('/')
  },
  methods: {
    update(){
      this.$emit('upd-section', this.editdata)
      this.$router.push('/')
    },
    // 郵便番号検索ボタン
    getAjaxzip (e) {
      const target = e.target.dataset
      AjaxZip3.onSuccess = ()=>{ // eslint-disable-line no-undef
        this.editdata.pref = this.$el.querySelector(`[name="${target.pref}"]`).value
        this.editdata.addr = this.$el.querySelector(`[name="${target.addr}"]`).value
      }
      AjaxZip3.zip2addr( target.zip, '', target.pref, target.addr ) // eslint-disable-line no-undef
    }
  }
})


